import { SearchStyle } from '../../Config';
import { ActionTypes as SearchActionTypes } from '../../actions/search';
import { ActionTypes as PageActionTypes } from '../../actions/page';
import { transformResult } from './utils';
export const initialState = {
    searchStyle: SearchStyle.resultsPage,
    inputValue: '',
    searchedTerm: '',
    isFetching: false,
    results: null,
    totalCount: null,
    currentPage: null,
    totalPages: null,
    isOpen: false,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PageActionTypes.PAGE_NAV_START:
            return initialState;
        case SearchActionTypes.SEARCH_INPUT_CHANGED: {
            return {
                ...state,
                inputValue: action.payload.searchTerm,
            };
        }
        case SearchActionTypes.SEARCH_FETCH_STARTED:
            return { ...state, isFetching: true };
        case SearchActionTypes.SEARCH_FAIL:
        case SearchActionTypes.SEARCH_CANCEL:
            return { ...state, isFetching: false };
        case SearchActionTypes.SEARCH_SUCCESS: {
            const { totalCount, totalPages, currentPage } = action.payload.searchArticles.pageInfo;
            if (state.searchedTerm === action.payload.searchedTerm &&
                state.results &&
                state.currentPage !== currentPage) {
                return {
                    ...state,
                    isFetching: false,
                    results: state.results.concat(action.payload.searchArticles.results.map((r) => transformResult(r, {
                        languageId: action.payload.languageId,
                        now: action.payload.now,
                    }))),
                    totalCount,
                    currentPage,
                    totalPages,
                };
            }
            return {
                ...state,
                isFetching: false,
                results: action.payload.searchArticles.results.map((r) => transformResult(r, {
                    languageId: action.payload.languageId,
                    now: action.payload.now,
                })),
                searchedTerm: action.payload.searchedTerm,
                totalCount,
                currentPage,
                totalPages,
            };
        }
    }
    return state;
};
export default reducer;
//# sourceMappingURL=resultsPage.js.map